/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Mic_StopInputs */

const en_us2_coach_mic_stop = /** @type {(inputs: Coach_Mic_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stop and transcribe`)
};

const pt_br2_coach_mic_stop = /** @type {(inputs: Coach_Mic_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parar e transcrever`)
};

const es_419_coach_mic_stop = /** @type {(inputs: Coach_Mic_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detener y transcribir`)
};

const pt_pt2_coach_mic_stop = /** @type {(inputs: Coach_Mic_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parar e transcrever`)
};

const fr_fr2_coach_mic_stop = /** @type {(inputs: Coach_Mic_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arrêter et transcrire`)
};

const de_de2_coach_mic_stop = /** @type {(inputs: Coach_Mic_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stoppen und umwandeln`)
};

const it_it2_coach_mic_stop = /** @type {(inputs: Coach_Mic_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ferma e trascrivi`)
};

/**
* | output |
* | --- |
* | "Stop and transcribe" |
*
* @param {Coach_Mic_StopInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_mic_stop = /** @type {((inputs?: Coach_Mic_StopInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Mic_StopInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_mic_stop(inputs)
	if (locale === "es-419") return es_419_coach_mic_stop(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_mic_stop(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_mic_stop(inputs)
	if (locale === "de-DE") return de_de2_coach_mic_stop(inputs)
	if (locale === "it-IT") return it_it2_coach_mic_stop(inputs)
	return en_us2_coach_mic_stop(inputs)
});
export { coach_mic_stop as "coach-mic.stop" }